// src/store/ticketSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchTickets,
  purchaseTickets,
} from "../../utilities/services/tickets";

// Async thunk for fetching tickets
export const getTickets = createAsyncThunk("tickets/fetchTickets", async () => {
  const response = await fetchTickets();
  return response.data.data;
});

// Async thunk for purchasing tickets
export const buyTickets = createAsyncThunk(
  "tickets/buyTickets",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await purchaseTickets(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.error || error.message);
    }
  }
);

// Ticket slice with initial state and reducers
const ticketSlice = createSlice({
  name: "tickets",
  initialState: {
    tickets: [],
    loading: false,
    loading2: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling getTickets
      .addCase(getTickets.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload;
      })
      .addCase(getTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch tickets.";
      })
      // Handling buyTickets
      .addCase(buyTickets.pending, (state) => {
        state.loading2 = true;
        state.error = null;
      })
      .addCase(buyTickets.fulfilled, (state, action) => {
        state.loading2 = false;
        state.purchaseSuccess = action.payload?.message;
      })
      .addCase(buyTickets.rejected, (state, action) => {
        state.loading2 = false;
        state.error =
          action.payload || "An error occurred while purchasing tickets.";
      });
  },
});

export default ticketSlice.reducer;
